import React, { useEffect, useState, useCallback, memo } from "react";
// REMOVED: Framer Motion import
import { createClient } from "contentful";
import "../../styles/BlogList.css";

const client = createClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
});

function AllBlogsPageComponent() {
  const [allPosts, setAllPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const { items } = await client.getEntries({
          content_type: "standingNextToAMountainBlog",
          order: "-fields.createdDate",
          select: "sys.id,fields.blogTitle,fields.blogSummary,fields.createdDate,fields.blogImage",
        });
        setAllPosts(items);
      } catch (err) { console.error("Error fetching posts:", err); }
      finally { setIsLoading(false); }
    })();
  }, []);

  const formatDate = useCallback((iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    return isNaN(d) ? "—" : new Intl.DateTimeFormat("en-US", { month: "long", day: "2-digit", year: "numeric" }).format(d);
  }, []);

  if (isLoading) {
    return <div className="blog-loadingState"><div className="blog-loader"></div></div>;
  }

  // REMOVED: All animation variants

  return (
    // Replaced <motion.div> with <div>
    <div className="blog-pageContainer">
      <header className="blog-hero">
        {/* Replaced <motion.h1> and <motion.p> with standard tags */}
        <h1 className="blog-heroTitle">All Blogs</h1>
        <p className="blog-heroSubtitle">
          Browse the complete collection from the mountain.
        </p>
      </header>

      <main className="blog-grid">
        {allPosts.map((post) => (
          <a
            key={post.sys.id}
            href={`/standing-next-to-a-mountain/blogDetails/${post.sys.id}`}
            className="blog-card"
          >
            <div className="blog-card-imageWrap">
              {post.fields.blogImage?.fields?.file?.url ? (
                <img src={`https:${post.fields.blogImage.fields.file.url}`} alt="" className="blog-card-image" />
              ) : null}
              <div className="blog-card-categoryTag">Blog Post</div>
            </div>
            <div className="blog-card-content">
              <p className="blog-card-date">{formatDate(post.fields.createdDate)}</p>
              <h3 className="blog-card-title">{post.fields.blogTitle}</h3>
              <p className="blog-card-summary">{post.fields.blogSummary}</p>
              {/* --- MODIFICATION START --- */}
              <div className="blog-card-button-container">
                <div className="blog-card-read-more">Read More</div>
              </div>
              {/* --- MODIFICATION END --- */}
            </div>
          </a>
        ))}
      </main>
    </div>
  );
}

export default memo(AllBlogsPageComponent);